import { useCallback } from 'react';
import { css } from '@emotion/react';
import { PanelPortal, PanelHeader } from '@frontend/panel-engine';
import { SchedulePulseTrayContent } from '@frontend/schedule';
import { Heading } from '@frontend/design-system';
import { PaddedContent } from '../../layout/padded-content';
import { useTopBarShallowStore } from '../../store/use-top-bar-store';
import { labelMap } from '../../utils/label-map';
import { TopBarPanelContent } from '../panels/top-bar-panel-scaffold';

export const SchedulePulsePanel = ({ onClose }: { onClose: () => void }) => (
  <PanelPortal id='schedulePulse' width='medium' onClose={onClose}>
    <PaddedContent css={{ paddingBottom: 0 }}>
      <header
        css={css`
          display: flex;
          justify-content: space-between;
        `}
      >
        <Heading
          level={2}
          css={{ marginBottom: 0, display: 'flex', gap: 8, alignItems: 'center' }}
          data-testid='tray-header'
        >
          {labelMap['schedulePulse']}
        </Heading>
        <PanelHeader.Close iconName='x' size='large' />
      </header>
    </PaddedContent>
    <TopBarPanelContent>
      <SchedulePulseTrayContent onClose={onClose} />
    </TopBarPanelContent>
  </PanelPortal>
);

export const SchedulePulsePanelWrapper = () => {
  const { isSchedulePulseOpen, setSchedulePulseOpen } = useTopBarShallowStore(
    'isSchedulePulseOpen',
    'setSchedulePulseOpen'
  );
  const closeSchedulePulse = useCallback(() => setSchedulePulseOpen(false), [setSchedulePulseOpen]);

  if (!isSchedulePulseOpen) {
    return null;
  }
  return <SchedulePulsePanel onClose={closeSchedulePulse} />;
};
